<template>
    <!-- eslint-disable -->
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 100 100">
      <defs>
        <clipPath id="clip-Facebook">
          <rect width="100" height="100"/>
        </clipPath>
      </defs>
      <g id="Facebook" clip-path="url(#clip-Facebook)">
        <path id="XMLID_1_" d="M82.593,59.273V51.3a4.251,4.251,0,0,1,4.455-4.831H98.185V29.345L82.84,29.254A19.451,19.451,0,0,0,61.849,50.127v9.028H52V79.089h9.967v49.835H81.9V79.089H96.677l1.879-19.934H82.593Z" transform="translate(-23.521 -29.188)" :fill="color"/>
      </g>
    </svg>
</template>
<script>
import { Colorable } from '../../mixins';

export default {
    name: 'IconFacebook',
    mixins: [Colorable],
};
</script>
